import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface ReminderMail {
  id: number
  _canSelect: boolean // 同利用者で先頭のみtrue
  userId: string
  name: string
  nameKana: string
  userBranchCode: SystemCode
  mailAddress: string
  collectionNo: string
  displayTitle: string
  sortTitle: string
  displayAuthor: string
  sortAuthor: string
  callNo: string
  lendBranchCode: SystemCode
  lendDate: string
  dueDate: string
  remindCount: number
  reserveCount: number
}

export function ReminderMailFromJSON(json: any): ReminderMail {
  return {
    id: exists(json, 'id') ? json.id : '',
    _canSelect: exists(json, '_can_select') ? json._can_select : false,
    userId: exists(json, 'user_id') ? json.user_id : '',
    name: exists(json, 'name') ? json.name : '',
    nameKana: exists(json, 'name_kana') ? json.name_kana : '',
    userBranchCode: exists(json, 'user_branch_code')
      ? SystemCodeFromJSON(json.user_branch_code)
      : defaultSystemCode(),
    mailAddress: exists(json, 'mail_address') ? json.mail_address : '',
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    sortTitle: exists(json, 'sort_title') ? json.sort_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    sortAuthor: exists(json, 'sort_author') ? json.sort_author : '',
    callNo: exists(json, 'call_no') ? json.call_no : '',
    lendBranchCode: exists(json, 'lend_branch_code')
      ? SystemCodeFromJSON(json.lend_branch_code)
      : defaultSystemCode(),
    lendDate: exists(json, 'lend_date')
      ? dateToPlainFormat(json.lend_date)
      : '',
    dueDate: exists(json, 'due_date') ? dateToPlainFormat(json.due_date) : '',
    remindCount: exists(json, 'remind_count') ? json.remind_count : '',
    reserveCount: exists(json, 'reserve_count') ? json.reserve_count : ''
  }
}
